import "swiper/css";

import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { Outlet, ScrollRestoration, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import ErrorBoundary from "@/components/ErrorBoundary";
import ErrorFallback from "@/components/ErrorFallback.tsx";
import ProgressBar from "@/components/layout/ProgressBar/ProgressBar.tsx";

import globalRouter from "@/globalRouter.ts";
import "@/styles/app.css";
import "@/styles/global.css";
import "@/utils/prototypes";

import "./i18n.ts";

const App = () => {
  globalRouter.navigate = useNavigate();
  const profileAge = localStorage.getItem("splay:profileAge");

  useEffect(() => {
    if (profileAge && +profileAge <= 12) {
      document.querySelector("html")?.setAttribute("data-theme", `kids-${profileAge}`);
    } else {
      document.querySelector("html")?.setAttribute("data-theme", `dark`);
    }
  }, [profileAge]);

  return (
    <ErrorBoundary renderFallback={(error, errorInfo) => <ErrorFallback error={error} errorInfo={errorInfo} />}>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name={"og:site_name"} content={"Splay"} />
        <title>{` Фильмы, сериалы, мультики разного жанра и многое другое без ограничений | Splay`}</title>
        <meta
          name="og:title"
          content={`Фильмы, сериалы, мультики разного жанра и многое другое без ограничений | Splay`}
        />
        <meta
          name="description"
          content={
            "Погрузитесь в мир SPLAY, смотрите что угодно. Вас ждут более 1000 Фильмов, Сериалов,Мультфильмов разного жанра, и многое другое"
          }
        />
        <meta
          name={"og:description"}
          content={
            "Погрузитесь в мир SPLAY, смотрите что угодно. Вас ждут более 1000 Фильмов, Сериалов,Мультфильмов разного жанра, и многое другое"
          }
        />
      </Helmet>
      <div className={"min-h-screen bg-surface font-sf-pro-display text-on-primary"}>
        <ProgressBar />
        <Outlet />
        <ScrollRestoration />
        <ToastContainer />
      </div>
    </ErrorBoundary>
  );
};

export default App;
